import { register } from "async-ops";
import { callMdaeApi } from "../../../call-web-api";
export const IMPORT_EHR_DOCUMENTATION = "IMPORT_EHR_DOCUMENTATION";


export const service = async (data) => {
  const options = {
    url: '/api/v1/documents/paw/ehr-downloads',
    type: "POST",
    body: JSON.stringify(data)
  };
  const response = await callMdaeApi(options);
  return response;
};



const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(IMPORT_EHR_DOCUMENTATION, service, mock);
